const reflow = (el) => {
  el.offsetHeight;
};

export default reflow;